import { BodyText, toast } from "@/components/ui";
import { TRACKERS } from "@/constants/Trackers";
import { EditableRecordButton } from "@/features/Patient/MedicalRecords/components/EditableRecordButton";
import { formatPhoneNumber } from "@/lib/formatters";
import { trackEvent } from "@/lib/tracking";
import { useState } from "react";
import type { z } from "zod";
import {
  type Profile,
  useUpdateProfilePhoneNumber,
} from "../network/useProfile";
import type { profilePhoneNumberFormSchema } from "../schemas";
import { UpdatePhoneNumberForm } from "./UpdatePhoneNumberForm";

export const PhoneNumberEditor = ({
  patientId,
  profile,
}: { patientId: string; profile: Profile }) => {
  const [isEditingPhoneNumber, setIsEditingPhoneNumber] = useState(false);
  const onSuccess = () => {
    setIsEditingPhoneNumber(false);
    toast.success("Phone number updated");
  };
  const { mutate: updateProfilePhoneNumber, isPending: isUpdatingPhoneNumber } =
    useUpdateProfilePhoneNumber(patientId, onSuccess);

  const handleSubmit = (
    values: z.infer<typeof profilePhoneNumberFormSchema>,
  ) => {
    if (!profile || !patientId) {
      toast.error("Unable to update phone number, please try again later.");
      return;
    }
    updateProfilePhoneNumber({ phoneNumber: values.phoneNumber, patientId });
  };
  if (isEditingPhoneNumber) {
    return (
      <UpdatePhoneNumberForm
        handleSubmit={handleSubmit}
        phoneNumber={profile.phoneNumber}
        isUpdatingPhoneNumber={isUpdatingPhoneNumber}
        setIsEditingPhoneNumber={setIsEditingPhoneNumber}
      />
    );
  }
  return (
    <EditableRecordButton
      title="Phone Number"
      onClick={() => {
        trackEvent(TRACKERS.EDIT_PHONE_NUMBER);
        setIsEditingPhoneNumber(true);
      }}
    >
      <BodyText size="sm">
        {profile?.phoneNumber
          ? formatPhoneNumber(profile?.phoneNumber)
          : "No phone number"}
      </BodyText>
    </EditableRecordButton>
  );
};
